import axios from 'axios';


function countNumber(moduleNum,traceNum,detailNum) {
	axios.post('/api/traceMobile', {
	 "moduleId": moduleNum,
	  "traceId": traceNum,
	  "detailId": detailNum
	})
	.then((response)=> {
		console.log(response)
	})
	.catch((error)=> {
		
	});
}


export default countNumber


// WEBPACK FOOTER //
// ./src/js/count.js